import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin: 0 -30px;
  padding: 20px 30px 0 30px;
`;

export type PageTemplateDashboardProps = React.ComponentProps<
  typeof StyledDiv
> & {
  innerRef?: React.MutableRefObject<HTMLDivElement | null>;
};

const PageTemplateDashboard: React.FC<PageTemplateDashboardProps> = ({
  innerRef,
  children,
  className,
  ...props
}) => {
  return (
    <StyledDiv
      ref={innerRef}
      className={`page-template-dashboard${className ? ` ${className}` : ''}`}
      {...props}
    >
      {children}
    </StyledDiv>
  );
};

export default PageTemplateDashboard;
